module.exports = __webpack_public_path__ + "img/onda2.425e48e5.png";